var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2296",
  "data-name": "Group 2296",
  transform: "translate(0)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_460",
  "data-name": "Rectangle 460",
  transform: "translate(509.37 165.853) rotate(135)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 3,
  opacity: 0.32
}, /*#__PURE__*/React.createElement("rect", {
  width: 234.551,
  height: 234.551,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 231.551,
  height: 231.551,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_461",
  "data-name": "Rectangle 461",
  transform: "translate(331.705 339.829) rotate(135)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 3,
  opacity: 0.32
}, /*#__PURE__*/React.createElement("rect", {
  width: 234.551,
  height: 234.551,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 231.551,
  height: 231.551,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_462",
  "data-name": "Rectangle 462",
  transform: "translate(509.37 513.806) rotate(135)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 3,
  opacity: 0.32
}, /*#__PURE__*/React.createElement("rect", {
  width: 234.551,
  height: 234.551,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 231.551,
  height: 231.551,
  fill: "none"
})));
function SvgRightPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 509.37,
    height: 679.658,
    viewBox: "0 0 509.37 679.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPattern);
export default __webpack_public_path__ + "static/media/right-pattern.db97e95c8395b11f480c9a0448b88997.svg";
export { ForwardRef as ReactComponent };